import { bigint, date, pgTable, timestamp, uuid } from "drizzle-orm/pg-core";

/**
 * Daily inventory valuation snapshot (ported from boxed FulfillmentInventorySnapshot).
 * One row per UTC day. All monetary columns are USD cents (bigint to be safe
 * against large aggregate valuations).
 */
export const inventorySnapshots = pgTable("inventory_snapshots", {
  id: uuid("id").primaryKey().defaultRandom(),
  day: date("day").notNull().unique(),
  totalInTransitPurchaseCents: bigint("total_in_transit_purchase_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalInventoryCostCents: bigint("total_inventory_cost_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalStaleInTransitPurchaseCents: bigint("total_stale_in_transit_purchase_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  softCapInventoryMarketValueCents: bigint("soft_cap_inventory_market_value_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  hardCapInventoryMarketValueCents: bigint("hard_cap_inventory_market_value_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalInventoryMarketValueCents: bigint("total_inventory_market_value_cents", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalQuantityWithoutAvailablePriceSlot: bigint("total_quantity_without_available_price_slot", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalQuantityWithoutAvailablePriceSlotValue: bigint(
    "total_quantity_without_available_price_slot_value",
    { mode: "number" },
  )
    .notNull()
    .default(0),
  totalAvailablePriceSlotWithoutQuantity: bigint("total_available_price_slot_without_quantity", {
    mode: "number",
  })
    .notNull()
    .default(0),
  totalAvailablePriceSlotWithoutQuantityValue: bigint(
    "total_available_price_slot_without_quantity_value",
    { mode: "number" },
  )
    .notNull()
    .default(0),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});
